// extracted by mini-css-extract-plugin
module.exports = {"radioButton":"RadioButton_radioButton__28xT4","label":"RadioButton_label__3Km5t","primaryText":"RadioButton_primaryText__3uhzM","secondaryText":"RadioButton_secondaryText__xTYfn"};